<template>
  <div class="w-full h-full relative">
    <layout-grid>
      <template #listPanel>
        <div class="p-4 space-x-4 space-y-4">
          <label for="guidInput" class="block mb-2">Use ifcGUID:</label>
          <input
            id="guidInput"
            v-model="guid"
            type="text"
            placeholder="ifcGUID"
            class="border p-2 rounded w-full"
          >
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded"
            @click="sendMessage({ action: 'send_databubble', ifcGUID: guid, textureID: 'Alert' })"
          >
            Send Alert
          </button>
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded"
            @click="sendMessage({ action: 'send_databubble', ifcGUID: guid, textureID: 'NewMessage' })"
          >
            Send New Message
          </button>
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded"
            @click="sendMessage({ action: 'send_databubble', ifcGUID: guid, textureID: 'Radiation' })"
          >
            Send Radiation
          </button>
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded"
            @click="sendMessage({ action: 'highlight', ifcGUID: guid })"
          >
            Highlight
          </button>
          <button
            class="bg-blue-500 text-white px-4 py-2 rounded"
            @click="sendMessage({ action: 'unhighlight', ifcGUID: guid })"
          >
            Unhighlight
          </button>
        </div>
      </template>

      <template #viewPanel>
        <div ref="viewer" class="absolute inset-0" />
      </template>

      <template #tablePanel>
        <div>
          <div>
            Message sent: {{ sentMessage }}
          </div>
          <div>
            Message received: {{ recievedMessage }}
          </div>
        </div>
      </template>
    </layout-grid>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import LayoutGrid from '../layouts/LayoutGrid.vue';
import { useUESettings } from '../composables/useUESettings';

let ws = null;
const viewer = ref(null);
const UESettings = useUESettings(viewer);
const sentMessage = ref(null);
const recievedMessage = ref(null);
const guid = ref('1gOtv1PH5ETwKKrGIbXv4c'); // Default GUID

watch(UESettings, newSettings => {
  if (ws && ws.readyState === WebSocket.OPEN) {
    sendMessage(JSON.stringify({ action: 'resize_window', ...newSettings }));
  }
}, { deep: true, immediate: true });

try {
  ws = new WebSocket('ws://localhost:1488');

  ws.onopen = () => {
    // Register with the server
    ws.send(
      JSON.stringify({
        type: 'register',
        name: 'WebApp'
      })
    );
  };

  ws.onmessage = handleMessage;

  ws.onclose = () => {
    console.log('Connection closed');
  };

  ws.onerror = () => {
    console.log('Connection error. Is the server running?');
    ws.close();
  };
} catch (error) {
  console.log('Failed to connect: ' + error.message);
}

function handleMessage(event) {
  try {
    const data = JSON.parse(event.data);
    recievedMessage.value = data;
    console.log('Received message:', data);
  } catch (error) {
    console.error('Error parsing message:', error);
  }
}

function sendMessage(message) {
  if (message && ws && ws.readyState === WebSocket.OPEN) {
    if (typeof message === 'object') {
      // Send plain text message
      ws.send(JSON.stringify(message));
      sentMessage.value = message;
    } else if (typeof message === 'string') {
      try {
        // Try to parse as JSON, but if that fails, try evaluating as JS object notation
        let jsonString;

        try {
          // First try standard JSON parsing
          JSON.parse(message);
          jsonString = message;
        } catch (jsonError) {
          // If standard parsing fails, try converting JS object notation to JSON
          try {
            // Convert JS object notation (with unquoted keys) to valid JSON
            // Replace property names without quotes with quoted versions
            const fixedJson = message.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2":').replace(/'/g, '"'); // Replace single quotes with double quotes

            JSON.parse(fixedJson);
            jsonString = fixedJson;
          } catch (jsError) {
            throw new Error('Invalid JSON format');
          }
        }

        // Send the JSON string
        ws.send(jsonString);
        sentMessage.value = message;
        console.log(`You sent JSON: ${jsonString}`, 'info');
      } catch (error) {
        console.log(`Invalid JSON: ${error.message}`, 'error');
      }
    }
  }
}

// right box   - 1Fvq1cpqzDte6Y8vwugdC$
// center box  - 1Fvq1cpqzDte6Y8vwugdEn
// left box    - 1gOtv1PH5ETwKKrGIbXvz4
// dakine -      1I$g_POLH5ogdNmdiOg$37
</script>
